import endpoints from '@app/src/api/endpoints'
import { FetchKey } from '@app/src/api/fetchHooks'
import useApi from '@app/src/hooks/api'
import type { OrganizationSettings } from '@app/src/wf-constants'
import { ONE_MINUTE_MS } from '@app/src/wf-constants'
import { useQuery } from '@tanstack/react-query'

const useAiScreeningEnabled = ({ enabled = true }: { enabled?: boolean } = {}): boolean => {
  const { get } = useApi()
  const { data } = useQuery({
    queryKey: [FetchKey.OrganizationSettings],
    queryFn: async () => (await get<OrganizationSettings>({ url: endpoints.organizationSettings })) ?? null,
    select: settings => settings?.aiScreeningEnabled ?? false,
    staleTime: ONE_MINUTE_MS,
    enabled,
  })
  return data ?? false
}

export default useAiScreeningEnabled
